import { Box, BoxProps, Heading, HStack, Stack, Text } from "@chakra-ui/react";
import React from "react";

export interface PageHeaderProps extends React.PropsWithChildren<BoxProps> {
  title: string;
  subtitle?: string;
  logo?: React.ReactNode;
}

export const PageHeader = ({
  title,
  subtitle,
  children,
  logo,
  ...props
}: PageHeaderProps) => (
  <Box as="section" pt={{ base: "4" }} pb={{ base: "6" }} {...props}>
    <HStack>
      {logo}
      <Stack
        flex="1"
        spacing="4"
        direction={{ base: "column", lg: "row" }}
        justify="space-between"
      >
        <Stack spacing="1">
          <Heading size={"2xl"} fontWeight="bold">
            {title}
          </Heading>
          {subtitle && <Text color="muted">{subtitle}</Text>}
        </Stack>
        {children}
      </Stack>
    </HStack>
  </Box>
);
